(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  // Hybrid: server renders manual + collection (includes out-of-stock). This fetches
  // Shopify's auto-generated recommendations (in-stock only) and moves them to the
  // front, keeping the collection/out-of-stock items to fill the remaining slots.
  function initRelated(root) {
    var section = (root || document).querySelector('.related-products[data-rec-url]');
    if (!section || section.dataset.recEnabled !== 'true') return;
    var grid = section.querySelector('.product-grid');
    if (!grid) return;
    var limit = parseInt(section.dataset.productLimit, 10) || 4;

    // Returns grid items (the slider wrapper if present, else the product-block itself).
    function itemsFrom(container) {
      return Array.prototype.map.call(
        container.querySelectorAll('product-block[data-product-id]'),
        function (pb) { return pb.closest('.slider__item') || pb; }
      );
    }

    fetch(section.dataset.recUrl)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (text) {
        var recItems = itemsFrom(new DOMParser().parseFromString(text, 'text/html'));
        if (!recItems.length) return; // API returned no recommendations — keep collection items

        var seen = {};
        var ordered = [];
        function consider(item) {
          if (ordered.length >= limit) return;
          var pb = item.matches('product-block[data-product-id]') ? item : item.querySelector('product-block[data-product-id]');
          if (!pb) return;
          if (seen[pb.dataset.productId]) return;
          seen[pb.dataset.productId] = true;
          ordered.push(item);
        }
        // Recommendations first, then the existing collection / out-of-stock items.
        recItems.forEach(consider);
        itemsFrom(grid).forEach(consider);

        grid.innerHTML = '';
        ordered.forEach(function (item) { grid.appendChild(item); });
        grid.classList.toggle('product-grid--single', ordered.length === 1);
      })
      .catch(function () { /* keep the server-rendered collection items */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initRelated(document); });
  } else {
    initRelated(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initRelated(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
